import React from "react";

import KidsLogo from '../images/kids.png';
import Logo from '../images/quiz-250.png';

export default function Header() {

  return (
    <header className="header">
			<div className="top clearfix">
				<a href="/#" className="responsive-menu-open">&nbsp; </a>
				
				<div className="right-icons">
					<span className="subsite-links">
						<a href="/#">Yes or No</a>
						<a href="/#">Learn</a>
					</span>
					
				</div> 
				
			</div> 
			<div className="bottom clearfix">
				<div className="title">
					<a href="/">

            <img width="125" alt="Quiz.ng" src={Logo} />
            &nbsp;
						<img width="80" alt="Quiz.ng" src={KidsLogo} />
					</a>
				</div>
				</div>
				
		</header>
  );
}
